import { render, staticRenderFns } from "./AddressNew.vue?vue&type=template&id=255c6077&scoped=true&"
import script from "./AddressNew.vue?vue&type=script&lang=ts&"
export * from "./AddressNew.vue?vue&type=script&lang=ts&"
import style0 from "./AddressNew.vue?vue&type=style&index=0&id=255c6077&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c6077",
  null
  
)

export default component.exports